export const inputContainerBaseClasses = 'input-container rounded-xl focus-within:ring-2 focus-within:ring-zinc-900 border border-zinc-400 bg-white overflow-hidden';

// Base classes for text inputs - Remove border, match rounding
export const inputElementBaseClasses = 'w-full box-sizing-border-box px-2 py-2 border-none focus:outline-none placeholder:text-zinc-500 text-base';

// Base classes for select dropdowns - includes appearance reset and custom arrow
export const selectElementBaseClasses = `
  block /* Layout */
  w-full /* Layout */
  h-12 /* Explicit height (3rem / 48px) */
  box-sizing-border-box /* Layout */
  px-2 py-3 /* Padding */
  text-base /* Text size reverted to base */
  placeholder:text-zinc-500 /* Text */
  focus:outline-none /* Focus */
  bg-white /* Explicitly set background to white */
  appearance-auto /* Force default browser appearance (including arrow) */
  /* Removed border, removed rounding */
  /* Removed custom arrow background styles */
`;

// Specific text color for selected option in selects
export const selectElementSpecificClasses = 'text-zinc-800'; 

// Base classes for the primary submit button
export const submitButtonBaseClasses = 'w-fit bg-zinc-900 text-white py-2 px-6 rounded-lg transition-colors mt-4';

// Classes for the submit button hover state
export const submitButtonHoverClasses = 'hover:bg-zinc-800';

// Classes for the submit button disabled state
export const submitButtonDisabledClasses = 'opacity-50 cursor-not-allowed';

// Classes for displaying validation error messages
export const errorMessageClasses = 'text-red-500 text-sm mt-1';

// Classes for form labels (used above selects in PropertyTransactionForm)
export const formLabelClasses = 'block text-xs font-medium text-zinc-600 mb-1'; 